// src/types.ts
export interface Segment {
    segmentid: number;
    segmentname: string;
}

export enum UserRole {
  Admin = 1,
  Seller = 3,
  ProductAdmin = 2,
  Finance = 4,
  MarketingAdmin = 5,
}

export interface UserIdentity {
    id: string;
    fullName: string;
    role_id: UserRole;
    role: string;
    avatar?: string;
}

export interface ICategory {
    id: number;
    category_name: string;
    category_description: string;
    is_virgin?: boolean;
    is_reprocessed?: boolean;
    moq?: number;
}

export interface IProductRecycle {
    id: number;
    category_id: number;
    subcategory_id: number;
    title?: string | null;
    description: string;
    price: number;
    seller_id: number;
    state_id?: number | null;
    status?: 'draft' | 'submitted' | 'approved' | 'rejected' | 'archived';
    rejection_reason?: string | null;
    submitted_at?: string | null;
    approved_at?: string | null;
    published_at?: string | null;
    created_by?: 'admin' | 'seller';
    image_1?: string | null;
    image_2?: string | null;
    image_3?: string | null;
    image_4?: string | null;
    category_name?: string;
    sub_category_name?: string;
    state_name?: string | null;
    seller_name?: string;
    dt_created?: string;
    dt_updated?: string;
    is_deleted?: boolean;
    deleted_at?: string | null;
}

export interface IDirectoryCategory {
    id: number;
    category_name: string;
    category_description: string;
}

export interface IDirectoryContact {
    id: number;
    company_name: string;
    gst_number?: string;
    first_name: string;
    last_name?: string;
    email_address?: string;
    address_line1?: string;
    address_line2?: string;
    address_city?: string;
    address_state?: number;
    address_pin?: string;
    phone_landline?: string;
    phone_mobile?: string;
}

export interface IOffer {
  id: number;
  post: string;
  expirydate: Date | string; // Date type can be used for date objects and string for ISO date strings
  /** App route key: products, watchlist, news-feed, directory, orders, profile */
  target_page?: string;
}

export interface ISubCategory {
    id: number;
    parent_id: number;
    sub_category_name: string;
    sub_category_description: string;
    category_name: string;
    category_id:number;
    is_virgin?: boolean;
    is_reprocessed?: boolean;
    parentCategory?: ICategory;  
  }

  export interface IProductSegment {
    id: number;
    product_segment_name: string;
    product_segment_description: string;
  }

  export interface ICityShipping {
    id: number;
    city_from: number;
    city_to: number;
    city_from_name: string;
    city_to_name: string;
  }

  export interface IProduct {
    id: number;
    category_id: number;
    category_name: string;
    sub_category_id: number;
    sub_category_name: string;
    product_name: string;
    product_grade: string;
    product_mfi: string;
    current_price: string;
    always_visible?: boolean;
    datasheet_filename?: string | null;
    product_segments?: string;
    favorite_count: number;
  }

  export interface IProductPricing {
    id: number;
    seller_id: number;
    category_name: string;
    sub_category_name?: string;
    product_name: string;
    product_grade: string;
    product_mfi: string;
    price?: number; 
    price_date?: Date; 
    user_id: number;
    product_id: number;
  }

  export interface IUserGst {
    state_id: number;
    gst_number: string;
    gst_registration_year?: number;
    is_primary?: boolean;
    state_name?: string;
    state_code?: string;
  }

  export interface ICustomerGst {
    state_id: number;
    gst_number: string;
    gst_registration_year?: number;
    is_primary?: boolean;
    state_name?: string;
    state_code?: string;
  }

  export interface ICustomer {
    id: number;
    customer_username?: string;
    company_name?: string;
    phone_mobile?: string;
    gst_number?: string;
    gst_registration_year?: number;
    gsts?: ICustomerGst[];
    gst_count?: number;
  }

  export interface IUser {
    id: number;
    user_name: string;
    user_first_name: string;
    user_last_name: string;
    email_address: string;
    address_line1: string;
    address_line2?: string; 
    address_city?: string;
    address_state?: string;
    address_country?: string;
    address_pin?: string;
    phone_landline?: string; 
    phone_mobile?: string; 
    gst_number?: string; 
    gst_registration_year?: number; 
    delivery_contact_person?: string;
    delivery_address_line1?: string;
    delivery_address_line2?: string; 
    delivery_address_city?: string;
    delivery_address_state?: string;
    delivery_address_country?: string;
    delivery_address_pin?: string;
    payment_terms?: string;
    has_newsletter?: boolean;
    avatar_url?: string; 
    segment_id?: number; 
    role_id?: number; 
    company_name?: string; 
    premium_seller?: boolean;
    gsts?: IUserGst[];
    gst_count?: number;
}
export interface IState {
  id: number;
  state_name: string;
  state_code: string;
  zone: string;
  active: boolean;
}

export interface IUserCities {
  id: number;
  city_name: string;
}

export interface IOrder {
  id: number;
  order_date: string; 
  order_customer_id: number;
  order_quantity: number;
  order_price: number; 
  order_base_total?: number;
  order_gst_rate?: number;
  order_gst_amount?: number;
  order_discount_type?: 'percent' | 'fixed';
  order_discount_value?: number;
  order_discount_amount?: number;
  order_commercial_credit_note_discount?: number;
  order_commercial_credit_note_amount?: number;
  order_commission: number;
  order_delivery_charges: number;
  order_status_id: number;
  order_tracking_url: string;
  order_product_id: number;
  order_total: number;
  customer_contact : string;
  product_name :string;
  product_grade : string;
  history_count : string;
}

export interface IOrderHistory {
  id: number;
  order_id: number;
  order_name: string;
  order_description: string;
  user_id: number;
  order_sub_status_id: number;
  comments:string;
  comment_date:Date;
  comment_user_id: number;
  order_sub_status : string;
  phone_mobile : string;
  user_name : string;
}


export interface IBlog {
  id: number;
  title?: string;
  description?: string;
  status?: string;
  source?: string;
  created_at?: string;
  published_at?: string | null;
  blog_name: string;
  blog_description: string;
  image?: File;
}


export interface BlogParams {
  id: string;
  title?: string;
  description?: string;
  image?: {
    rawFile: File;
    src: string;
    title: string;
  };
}

export interface IBid {
  id: number;
  bid_date: string; 
  bid_customer_id: number;
  bid_quantity: number;
  bid_price: number; 
  accepted_bid_quantity: number;
  accepted_bid_price: number; 
  bid_status_id: number;
  bid_product_id: number;
  bid_total: number;
  history_count : string;
}

export interface IInquiry {
  id: number;
  inquiry_date: string; 
  inquiry_customer_id: number;
  inquiry_quantity: number;
  inquiry_price: number; 
  accepted_inquiry_quantity: number;
  accepted_inquiry_price: number; 
  inquiry_status_id: number;
  inquiry_product_id: number;
  inquiry_total: number;
  inquiry_city_name?: string;
  inquiry_order_id?: number;
  customer_contact?: string;
  product_name?: string;
  product_grade?: string;
  inquiry_status?: string;
}
